import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {VueMasonryPlugin} from 'vue-masonry';

import formatNumber from '@/filters/format-number'
import formatDate from '@/filters/format-date'
import noZero from '@/filters/no-zero'

import Msg from '@/plugins/msg'


import sideBarMixin from "@/mixins/sidebarmx"
import carritoMixin from "@/mixins/carrito"
import globalesMixin from "@/mixins/globales"
import notificacion from "@/mixins/notificacion"
import Carrito from "@/mixins/carrito"
import Nuevos from "@/mixins/nuevos"
import Ofertas from "@/mixins/ofertas"
import Remates from "@/mixins/remates"

import '@/assets/css/site.css'
import "./assets/css/difarmer.css";
import "./assets/css/site-priv.css";

import '@fortawesome/fontawesome-free/css/all.css'

import 'aos/dist/aos.css';

import AOS from 'aos';
import vueSmoothScroll from 'vue2-smooth-scroll'
import swal from '@/plugins/swal'
import Vuelidate from "vuelidate";
import Chat from "@/mixins/chat.js";
import UUID from 'vue-uuid'

import floatTheadPlugin from '@/plugins/float-thead.js'

//import table from '@/plugins/table'

//directivas
import floatThead from '@/directives/floatThead'
Vue.use(floatThead)


Vue.use(UUID);
Vue.use(VueMasonryPlugin)
Vue.use(Vuelidate);
Vue.use(vueSmoothScroll);
AOS.init({
	once: true,
	disable: 'mobile'
});

//plugins
Vue.use(swal);
Vue.use(Msg);
//Vue.use(table)
Vue.use(floatTheadPlugin);

//mixins
Vue.mixin(sideBarMixin);
Vue.mixin(Chat);
Vue.mixin(carritoMixin);
Vue.mixin(globalesMixin)
Vue.mixin(notificacion);
Vue.mixin(Carrito);
Vue.mixin(Nuevos);
Vue.mixin(Ofertas);
Vue.mixin(Remates);

//filters
Vue.use(formatNumber)
Vue.use(formatDate)
Vue.use(noZero)


//directives
import Focus from "@/directives/focus"
import NumberDirective from "@/directives/number"

Vue.use(Focus)
Vue.use(NumberDirective)

Vue.config.productionTip = false

Vue.prototype.$loading = function(isLoading, msg="Espere un momento ..."){
    this.$store.commit('setLoading', isLoading)
    this.$store.commit('setMsgLoading', msg)
}


import VueGtag from "vue-gtag";
//google analytics
  Vue.use(VueGtag, {
    config: { 
      id: "G-5JZ51GVHLK"      
    }
  }, router);
  

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {

    document.dispatchEvent(new Event('vueAppMounted'));
  }
}).$mount('#app')
